module.exports = {
  projects: [
    {
      id: '',
      name: '',
      description: '',
      projectUrl: '',
      repositoryUrl: '',
      publishedDate: '',
      type: '',
      logo: {
        title: '',
        image: {
          src: 'https://source.unsplash.com/random',
        },
      },
    },
    {
      id: '',
      name: '',
      description: '',
      projectUrl: '',
      repositoryUrl: '',
      publishedDate: '',
      type: '',
      logo: {
        title: '',
        image: {
          src: 'https://source.unsplash.com/random',
        },
      },
    },
  ],
};
